import { render, staticRenderFns } from "./AddReportingCentre.vue?vue&type=template&id=506d2dfe&"
import script from "./AddReportingCentre.vue?vue&type=script&lang=ts&"
export * from "./AddReportingCentre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports